<template>
  <div class="floating-banner">
    <div class="banner-content">
      <div class="left-section">
        <div class="plan-info">
          <span class="plan-label">{{ type === 'store' ? '선택 플랜' : '선택 패키지' }}</span>
          <span class="plan-name">{{ selectedTitle }}</span>
        </div>
        <div class="price-info">
          <span class="price-label">합계 (VAT 포함)</span>
          <span class="price-amount">{{
            type === 'store' ? `월 기준 ${formattedPrice}원` : `${formattedPrice}원`
          }}</span>
        </div>
      </div>
      <div class="right-section">
        <button @click="handleClickFreeTrial" class="free-trial-btn">무료 상담하기</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingBanner',
  props: {
    type: {
      type: String,
      required: true,
    },
    selectedPlan: {
      type: Number,
    },
    plans: {
      type: Object,
    },
    packages: {
      type: Object,
    },
    selectedPackage: {
      type: Number,
    },
  },
  methods: {
    handleClickFreeTrial() {
      this.$emit('click-free-trial');
    },
  },

  computed: {
    selectedTitle() {
      if (this.type === 'store') {
        return this.plans[this.selectedPlan].title;
      } else {
        return this.packages[this.selectedPackage].title;
      }
    },
    formattedPrice() {
      if (this.type === 'store') {
        return (this.plans[this.selectedPlan].priceNumber * 1.1).toLocaleString();
      } else {
        return (this.packages[this.selectedPackage].priceNumber * 1.1).toLocaleString();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.floating-banner {
  width: 100%;
  max-width: 1188px;
  padding: 0 16px;
  height: 118px;
  position: fixed;
  bottom: 56px;
  left: 50%;
  transform: translateX(-50%);
  align-items: center;

  z-index: 100;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 24px;
  background: #1f2130;
  padding: 24px 32px;
}

.left-section {
  display: flex;
  gap: 24px;
  align-items: center;
}

.plan-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 16px;
  background: #373a4d;
  border-radius: 8px;
  width: 200px;
  height: 70px;
}

.price-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.plan-label {
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.7);
}

.price-label {
  color: var(--disabled_dark, #c2c2c2);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

.plan-name {
  color: var(--inversed, #fff);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
}

.price-amount {
  color: var(--inversed, #fff);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
}

.right-section {
  display: flex;
  align-items: center;
}

.free-trial-btn {
  width: 180px;
  height: 52px;
  padding: 16px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  background: #fff;

  color: var(--default-color);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
</style>
